import { AdminBreadcrumbsProps, Breadcrumbs } from '@g17eco/molecules/breadcrumbs';
import { generateUrl } from '@routes/util';
import { emissionsTrackerRoutes } from '../../routes';

export const EmissionsAdminBreadcrumbs = ({ breadcrumbs, initiativeId }: AdminBreadcrumbsProps) => {
  const rootUrl = generateUrl(emissionsTrackerRoutes.EMISSIONS_ADMIN, { initiativeId });
  return <Breadcrumbs breadcrumbs={breadcrumbs} rootLabel={'Admin Settings'} rootUrl={rootUrl} />;
};
